
import { Component, Vue, Ref } from 'vue-property-decorator'
import { EnterpriseService } from '@/services'
import CompanyTable from './components/company_table.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import FullLoading from '@/components/full_loading/index.vue'

@Component({
    name: 'enterprise-keyword',
    components: {
        CompanyTable,
        ScrollTo,
        FullLoading
    }
})
export default class Keyword extends Vue {
    private companyList = []
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private query = ''
    private isLoading = false
    private approvalStatus = 1
    @Ref('scrollRef') private scrollEl!: ScrollToType

    private async mounted() {
        this.getCompanyList()
    }

    private showLoading() {
        this.isLoading = true
    }

    private hideLoading() {
        this.isLoading = false
    }

    /** 获取机构列表 */ 
    private async getCompanyList() {
        this.showLoading()
        const params = {
            query: this.query,
            check: this.approvalStatus,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await EnterpriseService.getCompanyList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            // this.companyList = result.data.list
            this.companyList = result.data.list.map((item: any) => {
                let keywords = []
                try {
                    if (item.keywords_check && item.keywords_check !== '') {
                        keywords = JSON.parse(item.keywords_check)
                    }
                } catch (e) {
                    keywords = []
                }
                return {
                    ...item,
                    keywords,
                    check: this.mapIsDeletedToCheck(item.is_deleted)
                }
            })
        }
        this.hideLoading()
    }   

    private reset() {
        this.pageIndex = 1
        this.pageTotal = 0
    }

    private onSearch() {
        this.reset()
        this.getCompanyList()
    }

    private onResetInput() {
        if (!this.query) return
        this.query = ''
        this.getCompanyList()
    }

    private onApprovalStatusChange(status: number) {
        this.approvalStatus = status
        this.getCompanyList()
    }
    private mapIsDeletedToCheck(isDeleted: number): number {
        switch (isDeleted) {
            case 0:
            case 3:
                return 1
            case 1:
                return 3
            case 2:
                return 2
            default:
                return 1
        }
    }
    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getCompanyList)
    }
}
